export default __webpack_public_path__ + "static/media/desapedia.c966ab7d.png";